import React from 'react';

import { Footer, Row, BackButton, NextButton, ButtonText } from './WizardFooter.styles';

const ArrowRight = (): React.ReactElement => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden>
    <path
      d="M4.167 10h11.666M11.667 5.833 15.833 10l-4.166 4.167"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ArrowLeft = (): React.ReactElement => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden>
    <path
      d="M15.833 10H4.167M8.333 5.833 4.167 10l4.166 4.167"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export type WizardFooterProps = {
  nextLabel: string;
  onNext?: () => void;
  onBack?: () => void;
  showBack?: boolean;
  nextDisabled?: boolean;
  /** Optional content rendered above the back/next buttons (e.g. a total row). */
  extra?: React.ReactNode;
};

export const WizardFooter = ({
  nextLabel,
  onNext,
  onBack,
  showBack = false,
  nextDisabled = false,
  extra,
}: WizardFooterProps): React.ReactElement => (
  <Footer>
    {extra}
    <Row>
      {showBack ? (
        <BackButton type="button" data-ga-id="cfg-wizard-footer-back" onClick={onBack}>
          <ArrowLeft />
          <ButtonText text="Back" />
        </BackButton>
      ) : (
        <span />
      )}

      <NextButton type="button" data-ga-id="cfg-wizard-footer-next" onClick={onNext} disabled={nextDisabled}>
        <ButtonText text={nextLabel} />
        <ArrowRight />
      </NextButton>
    </Row>
  </Footer>
);

export default WizardFooter;
